export default __webpack_public_path__ + "bad253ae856978e78462f40db68fef66.svg";